import React, { Component } from 'react';
import { connect } from 'react-redux';
import {Box, MainHeadingContainer, MainHeading, BoxContent, NoData} from '../../StyledComponents';
import Slider from 'rc-slider';
import styled, { css } from 'styled-components';
import _ from 'lodash';
import Toggle from 'material-ui/Toggle';

const createSliderWithTooltip = Slider.createSliderWithTooltip;
const Range = createSliderWithTooltip(Slider.Range);

const PriceIndexViewContainer = styled.div`
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;

  @media only screen and (max-width: 991px), print {
    min-height: 400px;
  }

  @media only screen and (max-width: 524px) {
    min-height: 350px;
  }
`;

const ScoreHeading = styled.h1`
  margin-bottom: 0px;
  margin-top: 0;
`;

const ScoreLabelContainer = styled.div`
 &:hover {
      z-index: 999999;
    }

  &:after {
      position:absolute;
      content:"\00a0";
      display:block;
      border-radius:50%;
      left:-25px;
      width:13px;
      height:13px;
      margin-top: -17px;
  }
  &.score:after {
      background:#5ab99a;
  }
  &.average:after {
      background:#fd7923;
  }
  &.competitor:after {
      background:#cf6768;
  }


`;

const ScoreLabel = styled.div`
  text-align: left;
  color: #fff;
  white-space: nowrap;
  padding: 2px 5px;

  &.score {
      background:#5ab99a;
      z-index:999;
  }

  &.average {
      background:#fd7923;
  }

  &.competitor {
      background:#cf6768;
     }

  &.score:hover {
      z-index: 999999;
    }

  ${props => props.leftAlign && css`
    position: relative;
    left: calc(-100% - 35px);
  `}

`;

const PriceIndexRange = styled(Range)`
  background: transparent;
  left: calc(50%);
  transform: translateX(-50%);
`;

const SmallLabel = styled.span`
  font-size:11px;
`;


const toggleStyles = {
  block: {
    maxWidth: 250,
    float: 'right',
  },
  toggle: {
    marginBottom: 16,
  },
  thumbOff: {
    backgroundColor: '#fff',
  },
  trackOff: {
    backgroundColor: '#999',
  },
  thumbSwitched: {
    backgroundColor: '#fff',
  },
  trackSwitched: {
    backgroundColor: '#5ab99a',
  },
  labelStyle: {
    color: 'white',
    fontWeight:'normal'
  },
};

class PriceIndexView extends Component {
  constructor(props) {
      super(props);
      this.state = {
        showCompetitors: true
      };
  }

  getSliderValues(data) {
    let values = [parseFloat(data.value), 100];

    if (this.state && this.state.showCompetitors) {
      let competitors = data.competitors;

      _.map(competitors, (comp, key) => {
        values.push(comp.value);
      });
    };

    return values;
  }

  getSliderMarks(data) {
    let competitors = data.competitors;
    let allValues = [parseInt(data.value, 10), 100];
    _.map(competitors, (comp, key) => {
      allValues.push(comp.value);
    });

    function sortNumber(a,b) {
      return a - b;
    }

    allValues.sort(sortNumber);
    let leftAlign = function(val) {
      return allValues.indexOf(val) %2 === 0;
    };

    let marks = {
      100: {
        label: <ScoreLabelContainer className="average"><ScoreLabel leftAlign={leftAlign(100)} className="average small-font-size">AVERAGE: 100</ScoreLabel></ScoreLabelContainer>,
      },
    };

    if (data && data.value) {
      marks[parseInt(data.value, 10)] = {
        label: <ScoreLabelContainer className="score"><ScoreLabel leftAlign={leftAlign(data.value)} className="score small-font-size">YOUR POSITION: {data.value}</ScoreLabel></ScoreLabelContainer>,
      };
    };

    if (this.state && this.state.showCompetitors) {
      _.map(competitors, (comp, key) => {
        marks[comp.value] = {
          label: <ScoreLabelContainer className="competitor"><ScoreLabel leftAlign={leftAlign(comp.value)} className="competitor small-font-size">{comp.name}: {comp.value}</ScoreLabel></ScoreLabelContainer>,
        };
      });
    };


    return marks;
  }

  toggleCompetitors(e, val) {
    this.setState({showCompetitors: val});
  }

  render() {
    const { data, printBreak } = this.props;

    const placeholderData = {
        "type": "priceIndex",
        "title": "Price index",
        "value": 91,
        "competitors": [
          {
            "name": "Competitor 1",
            "value": 137
          },
          {
            "name": "Competitor 2",
            "value": 128
          },
          {
            "name": "Competitor 3",
            "value": 52
          }
        ]
      };

    const disabled = !data;
    const _data = data || placeholderData;
    const values = [_data.value];

    _.forEach(_data.competitors, function(obj,i) {
      values.push(obj.value);
    });

    //const min = (Math.min(...values) < 50) ? 0:50;
    //const max = (Math.min(...values) > 150) ? 200:150;

    const min = 0;
    const max = 200;

    return (
      <Box className={printBreak ? 'print-page-break-after' : ''} {...this.props}>
        <PriceIndexViewContainer>
          <div className="text-center priceIndexComponent">
            <MainHeadingContainer>
              <MainHeading className="normal-font-size text-left">Price Index</MainHeading>
            </MainHeadingContainer>
            <BoxContent disabled={disabled}>
              <span className="small-font-size">Your position</span>
              <ScoreHeading className="super-large-font-size">{_data && _data.value}</ScoreHeading>

              <div style={toggleStyles.block}>
                <Toggle
                  className="small-font-size"
                  label="Competitors"
                  style={toggleStyles.toggle}
                  labelStyle={toggleStyles.labelStyle}
                  thumbStyle={toggleStyles.thumbOff}
                  trackStyle={toggleStyles.trackOff}
                  thumbSwitchedStyle={toggleStyles.thumbSwitched}
                  trackSwitchedStyle={toggleStyles.trackSwitched}
                  toggled={this.state.showCompetitors}
                  onToggle={(e, val) => this.toggleCompetitors(e,val)}
                />
              </div>

              <div style={{position:'absolute',top:'130px',bottom:'60px', left:'0',right:'0',marginLeft:'auto',marginRight:'auto'}}>
                <SmallLabel className="small-font-size">{max}</SmallLabel>

                {_data && (
                  <PriceIndexRange
                    disabled
                    vertical
                    count={2}
                    value={this.getSliderValues(_data)}
                    className="priceIndexSlider"
                    trackStyle={[{backgroundColor: 'transparent' }]}
                    railStyle={{ backgroundColor: '#b7b7b7' }}
                    handleStyle={[{display:'none'}]}
                    min={min}
                    max={max}
                    marks={this.getSliderMarks(_data)}
                  />

                )}
                <SmallLabel className="small-font-size">{min}</SmallLabel>
              </div>
            </BoxContent>
            {disabled && <NoData/>}
          </div>
        </PriceIndexViewContainer>
      </Box>
    );
  }
}

function mapStateToProps(state, ownProps) {
    return {
        uid: state.user.uid
    };
}

export default connect(mapStateToProps)(PriceIndexView);



// WEBPACK FOOTER //
// ./src/components/dataViews/detailViews/PriceIndexView.js